import {Box, FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import React from "react";

const DynamicButtonFields = ({buttonType, card, index, handleCardChange}) => {

    if (buttonType === "quick_reply")
        return (
            <Box sx={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2}}>
                <FormControl fullWidth>
                    <InputLabel>Select type</InputLabel>
                    <Select value="quick_reply" disabled>
                        <MenuItem value="quick_reply">Quick Reply</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Quick Reply Title"
                    value={card[`button_${index}_title`] || ""}
                    onChange={(e) =>
                        handleCardChange(card.id, `button_${index}_title`, e.target.value)
                    }
                    fullWidth
                />
            </Box>
        );

    if (buttonType === "url")
        return (
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    gap: 2,
                    mt: 1.5,
                }}
            >
                <TextField
                    label="Button Title"
                    value={card[`button_${index}_title`] || ""}
                    onChange={(e) =>
                        handleCardChange(card.id, `button_${index}_title`, e.target.value)
                    }
                />
                <FormControl fullWidth>
                    <InputLabel>Select URL type</InputLabel>
                    <Select
                        value={card[`button_${index}_urlType`] || ""}
                        onChange={(e) =>
                            handleCardChange(
                                card.id,
                                `button_${index}_urlType`,
                                e.target.value
                            )
                        }
                    >
                        <MenuItem value="static">Static</MenuItem>
                        <MenuItem value="dynamic">Dynamic</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Button Value"
                    value={card[`button_${index}_value`] || ""}
                    onChange={(e) =>
                        handleCardChange(card.id, `button_${index}_value`, e.target.value)
                    }
                />
            </Box>
        );

    if (buttonType === "phone")
        return (
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: 2,
                    mt: 1.5,
                }}
            >
                <TextField
                    label="Button Title"
                    value={card[`button_${index}_title`] || ""}
                    onChange={(e) =>
                        handleCardChange(card.id, `button_${index}_title`, e.target.value)
                    }
                />
                <TextField
                    label="Button Value"
                    placeholder="+521234567890"
                    value={card[`button_${index}_value`] || ""}
                    onChange={(e) =>
                        handleCardChange(card.id, `button_${index}_value`, e.target.value)
                    }
                />
            </Box>
        );

    return null;
};
export default DynamicButtonFields;